<script setup lang="ts">
import { computed } from 'vue';
import ShareButtonGroup from '@shared/app/components/atoms/ShareButtonGroup.vue';
import { useRuntimeConfig } from '#app/nuxt';
import { useRoute } from '#app/composables/router';
import { useUserAgentState } from '~/composables/useUserAgentState';

const config = useRuntimeConfig();
const route = useRoute();
const { isFromNavel } = useUserAgentState();

// NOTE: アプリが付けたクエリを共有先に持ち込まないよう、パスだけを使う
const pageUrl = computed(() => `${config.public.siteUrl}${route.path}`);
</script>

<template>
  <!-- NOTE: アプリ（WebView）ではSNSシェアボタンを出さず、リンクのコピーで共有してもらう -->
  <AtomsCopyUrlButton v-if="isFromNavel" class="mb-5" :url="pageUrl" />
  <ShareButtonGroup v-else />
</template>
